import { doPublicRequest, doRequest } from "./baseapi-service";
import {
  getAluno as getAlunoLocal,
  setAluno as setAlunoLocal,
} from "./auth-service";

import { API_URL } from "../../.env.json";

const URL = API_URL;
const RESOURCE = "alunos/";

export const registarSenha = (aluno) => {
  return doRequest(
    URL,
    RESOURCE,
    "POST",
    aluno,
    "registrar-senha"
  );
};

export const autentica = (aluno) => {
  console.log(URL);
  return doPublicRequest(URL, RESOURCE + "autenticar/", "POST", aluno);
};

export const atualizar = (aluno) => {
  return doRequest(URL, RESOURCE, "PATCH", aluno, aluno.cpf);
};

export const validarDataNascimento = (cpf, dataNasc) => {
  const params = cpf + "/validar-data-nascimento";
  return doPublicRequest(URL, RESOURCE, "POST", { dataNasc }, params);
};

export const getStatusPorCpf = async (cpf) => {
  const params = cpf + "/status";
  return doPublicRequest(URL, RESOURCE, "GET", "", params);
};

export const getAluno = async (refresh) => {
  const alunoLocal = await getAlunoLocal();
  if (refresh) {
    const response = await doRequest(URL, RESOURCE, "GET", "", alunoLocal.cpf);
    if (response.ok) {
      const alunoApi = await response.json();
      setAlunoLocal(alunoApi);
      return alunoApi;
    }
    return [];
  } else {
    return alunoLocal;
  }
};

export const adicionarTelefone = async (telefone) => {
  const alunoLocal = await getAlunoLocal();
  const params = alunoLocal.cpf + "/telefones";
  return await doRequest(URL, RESOURCE, "POST", telefone, params);
};

export const alterarSenha = async (senhaAntiga, novaSenha) => {
  const alunoLocal = await getAlunoLocal();
  return await doRequest(
    URL,
    RESOURCE + "/alteracao-senha",
    "POST",
    { senhaAntiga, novaSenha },
    ""
  );
};

export const excluirConta = async () => {
  const alunoLocal = await getAlunoLocal();
  return await doRequest(URL, RESOURCE, "DELETE", "", "");
};

export const validarCodigoSMS = async (telefone) => {
  return await doRequest(
    URL,
    RESOURCE + "/telefones/verificacao",
    "POST",
    telefone
  );
};

export const enviarCodigoSMS = async (telefoneId, whatsapp) => {
  const alunoLocal = await getAlunoLocal();
  const params = "/telefones/" + telefoneId + "/sms";
  return await doRequest(URL, RESOURCE, "POST", { whatsapp }, params);
};

export const atualizarTelefonePrincipal = async (telefone) => {
  const alunoLocal = await getAlunoLocal();
  const params = alunoLocal.cpf + "/telefones/" + telefone.id;
  return await doRequest(URL, RESOURCE, "PATCH", {}, params);
};

export const removerTelefone = async (telefone) => {
  const alunoLocal = await getAlunoLocal();
  const params = alunoLocal.cpf + "/telefones/" + telefone.id;
  return await doRequest(URL, RESOURCE, "DELETE", "", params);
};

export const listarVagas = async () => {
  const alunoLocal = await getAlunoLocal();

  return await doRequest(URL, RESOURCE + "/vagas", "GET", "");
};

export const listarVagasPublicas = async () => {
  const alunoLocal = await getAlunoLocal();

  return  doRequest(URL, "vagas-publicas", "GET", "");
};

export const candidatarVaga = async (vagaId) => {
  const alunoLocal = await getAlunoLocal();

  return await doRequest(
    URL,
    RESOURCE + `/vagas/${vagaId}/candidatura`,
    "POST",
    {}
  );
};

export const dispensarVaga = async (vagaId) => {
  return await doRequest(
    URL,
    RESOURCE + `/vagas/${vagaId}/candidatura`,
    "DELETE",
    {}
  );
};

export const adicionarToken = async (token) => {
  return await doRequest(URL, RESOURCE + `/token-notificacoes`, "POST", {
    token,
  });
};
